import script from "./StoreReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreReceipt.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ImageUploaderNeue from "@/components/neue/ImageUploaderNeue.vue";
import InputArea from "@/components/neue/InputArea.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
script.components = Object.assign({}, { ImageUploaderNeue, InputArea, NeueLoading, NeueToggle, SettingsSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ImageUploaderNeue, InputArea, NeueLoading, NeueToggle, SettingsSection }, script.__o.components);}